<template>
  <component :is="element" :class="{ chip__rounded: rounded }" class="chip">
    <slot />

    <button v-if="close" class="chip--close" @click="$emit('close', $event)">
      <Icon icon="x-icon" />
    </button>
  </component>
</template>

<script>
/**
 * Componente usado para apresentar pequenas informações no layout, podendo ou não
 * serem interativos
 */
export default {
  name: 'Chip',
  props: {
    /** Elemento html que é gerado */
    element: {
      type: String,
      default: 'div'
    },
    /** Se possuí bordas arredondadas */
    rounded: {
      type: Boolean,
      default: false
    },
    /** Se possuí botão de remover */
    close: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.chip {
  display: inline-flex;
  align-items: center;
  padding: 8px 15px;
  border: 1px solid $gray-border;
  background-color: $white;
  font-size: font-size('size-small');

  &__rounded {
    border-radius: 50px;
  }

  &--close {
    @include reset-button();
    margin-left: 15px;
    color: $gray-dark;

    .icon {
      width: 9px;
      height: 9px;
    }
  }
}
</style>
